import React, { Component } from "react";
import Slider from "react-slick";
import { portfolioSlick2 } from "../../../page-demo/script";
import {Link} from "react-router-dom";


const PortfolioList = [
    {
        image: 'image-1',
        category: 'Development',
        title: 'Custom Ecommerce Integration',
        link: '' 
    },
    {
        image: 'image-2',
        category: 'Development',
        title: 'System Performance Optimization',
        link: '' 

    },
    {
        image: 'image-3',
        category: 'Development',
        title: 'EDI Integration',
        link: '' 
    },
    {
        image: 'image-4',
        category: 'Development',
        title: 'Custom Form Development',
        link: '' 
    },
    {
        image: 'image-3',
        category: 'Development',
        title: 'Custom Financial Reporting',
        link: '' 
    },
    {
        image: 'image-4',
        category: 'Development',
        title: ' Sales Intelligence ',
        link: '' 
    }
]

class Portfolio extends Component{
    render(){
        let title = 'Selected Projects',
        description = 'The projects we are hired to do are typically built custom to a clients needs utilizing a large prebuilt library. We build everything custom, but we don\'t reinvent the wheel'
        return(
            <React.Fragment>
                <div className="portfolio-wrapper">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="section-title">
                                    <h2>{title}</h2>
                                    <p>{description}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="portfolio-slick-activation mt--70 mt_sm--40">
                        <Slider {...portfolioSlick2}>
                            {PortfolioList.map((value , index) => (
                                <div className="portfolio" key={index}>
                                    <div className="thumbnail-inner">
                                        <div className={`thumbnail ${value.image}`}></div>
                                        <div className={`bg-blr-image ${value.image}`}></div>
                                    </div>
                                    <div className="content">
                                        <div className="inner">
                                            <p>{value.category}</p>
                                            <h4 className="title"><a href="/portfolio-details">{value.title}</a></h4>
                                            <div className="portfolio-button">
                                                <a className="rn-btn" href="/portfolio-details">Case Study</a>
                                            </div>
                                        </div>
                                    </div>
                                    <Link className="link-overlay" to="/portfolio-details"></Link>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
export default Portfolio;